import { HTMLAttributes } from 'react'

export default (props: HTMLAttributes<SVGElement>) => (
  <svg
    onClick={props.onClick}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform='translate(4.91, 10)'>
      <path d='m0,3.49V0h15v3.49H0Z' fill='var(--button-label-color)' />
    </g>
  </svg>
)
